/**
 * @file ScrollProgress.tsx
 * @description Thermal gradient scroll progress indicator
 * 
 * Displays a slim progress bar at the top of the viewport showing
 * page scroll progress with the brand's thermal gradient.
 */

import { useScroll, useTransform, useReducedMotion } from "@/lib/motion";
import { m } from "@/lib/motion";

export function ScrollProgress() {
  const prefersReducedMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);

  // Skip for reduced motion users
  if (prefersReducedMotion) {
    return null;
  }

  return (
    <m.div
      className="fixed top-0 left-0 right-0 h-1 bg-gradient-thermal origin-left z-50"
      style={{ scaleX }}
      aria-hidden="true"
    />
  );
}
